module.exports = function getResource(label) {
    const resources = { onlyAFewLeft: 'only a few left' };
    return resources[label];
};
